import { useNextRouter } from '@/data/Content/_NextRouter';
import { DATA_KEY, fetcher } from '@/data/Content/_StockBalance';
import { useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import useSWR from 'swr';

export const useStockBalance = (catentryId: string) => {
	const router = useNextRouter();
	const { settings } = useSettings();
	const { storeId } = getClientSideCommon(settings, router);
	const { user } = useUser();
	const { data: stockData, isLoading } = useSWR(
		storeId ? [{ storeId }, DATA_KEY, user?.isLoggedIn, catentryId] : null,
		async ([{ storeId }]) => fetcher(true)(storeId, catentryId),
		{ revalidateOnFocus: false }
	);

	return {
		...stockData,
		isLoading,
	};
};
